<template>
  <div class="backdrop">
    <div class="backdrop-top">
      <div class="title-box">
        <img src="../../../assets/images/return.png" @click="$router.go(-1)"><span>耗材盘点详情</span>
      </div>
      <div class="list-wrapper">
        <div class="list-detail">
          <div class="detail-box">
            <div class="title">{{detail.goods_name}}</div>
            <div class="describe"><label>物品编码</label>{{detail.goods_num}}</div>
            <div class="describe"><label>应盘数</label>{{detail.due_count}}</div>
          </div>
        </div>
        <div class="row-item" style="margin-top: 8px">
          <label style="flex: 1;font-weight: 600;">盘点信息</label>
          <div>{{detail.stocktake_member_name}}</div>
        </div>
        <div class="row-item">
          <label>数量</label>
          <input type="text" v-model="detail.real_count" placeholder="请输入数量" >
        </div>
        <div class="row-item">
          <label>盘点备注</label>
          <input type="text" v-model="detail.remark" placeholder="请输入盘点备注" >
        </div>
      </div>
    </div>
    <div class="footer-wrapper" v-if="show_stocktake_btn == 1">
      <button class="delete-btn" @click="save(2)">撤销盘点</button>
      <button class="preserve-btn" @click="save(1)">保存盘点</button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'StocktakingDetail',
  metaInfo: {
    title: '耗材盘点'
  },
  data () {
    return {
      stocktaking_id: 0,
      show_stocktake_btn: 0,
      detail: {},
      before_page_name: '' // 前页名称，用于跳回判断
    }
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // beforeRouteEnter不能通过this访问组件实例，但是可以通过 vm 访问组件实例
      vm.before_page_name = from.name
    })
  },
  created () {
    // 解决安卓软键盘弹出布局问题
    let bodyHeight = document.documentElement.clientHeight + 'px'
    window.addEventListener('resize', () => {
      document.body.style.height = bodyHeight
    })

    this.stocktaking_id = this.$route.query.stocktaking_id
    this.show_stocktake_btn = this.$route.query.show_stocktake_btn
    this.detail = JSON.parse(this.$route.query.detail)
    if (this.detail.stocktake_status === 0) { // 未盘
      this.detail.real_count = ''
    }
  },
  methods: {
    // 保存
    save (type) {
      if (type === 2) { // 撤销盘点
        if (!this.detail.stocktaking_goods_id) { // 当前正在添加盘点物品，没有盘点数据可撤销，直接返回列表页即可
          if (this.before_page_name === 'StocktakingEnterCode') {
            this.$router.go(-2)
          } else {
            this.$router.go(-1)
          }
          return false
        }
        this.detail.real_count = '' // 撤销盘点，实盘数量传空即可
      }
      this.axios.post('/wechat/stocktaking/editStocktaking', {
        member_id: this.memberId,
        village_id: this.villageId,
        stocktaking_id: this.stocktaking_id,
        goods: JSON.stringify([{'goods_id': this.detail.goods_id, 'real_count': this.detail.real_count, 'remark': this.detail.remark}])
      }).then((res) => {
        if (res.data.status === 1) {
          this.$toast({
            message: '保存成功',
            duration: 5000
          })
          if (this.before_page_name === 'StocktakingEnterCode') {
            this.$router.go(-2)
          } else {
            this.$router.go(-1)
          }
        } else {
          this.$toast({
            message: res.data.info,
            duration: 5000
          })
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    }
  }
}
</script>
<style scoped>
.backdrop {
  background-color: #f6f6f6;
  overflow: hidden;
}
.backdrop-top {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.footer-wrapper {
  width: 100%;
  height: 50px;
  font-size: 16px;
  display: flex;
}
.footer-wrapper button {
  flex: 1;
  margin: 0;
  font-size: 14px;
}
.footer-wrapper .delete-btn {
  background-color: #ffffff;
  border: none;
  border-top: 1px solid #d9d9d9;
}
.footer-wrapper .preserve-btn {
  background-color: #7090fd;
  border: none;
  border-top: 1px solid #7090fd;
  color: #ffffff;
}
.list-wrapper .list-detail {
  background-color: #ffffff;
  padding: 10px;
}
.list-wrapper .list-detail .detail-box {
  background-color: #f6f6f6;
  padding: 10px;
}
.list-wrapper .list-detail .detail-box .title {
  font-weight: 600;
  font-size: 16px;
}
.list-wrapper .list-detail .detail-box .describe {
  font-size: 14px;
  margin-top: 10px;
}
.list-wrapper .list-detail .detail-box .describe label {
  display: inline-block;
  width: 80px;
  color: #666;
}
.list-wrapper .row-item {
  display: flex;
  /* margin: 0 15px; */
  padding: 10px 15px;
  border-bottom: 1px solid #f6f6f6;
  font-size: 15px;
  background-color: #ffffff;
}
.list-wrapper .row-item input {
  flex: 1;
  width: 100%;
  border: none;
  outline: none;
  font-size: 15px;
  text-align: right;
  padding: 0;
}
.list-wrapper .row-item img {
  width: 12px;
  height: 12px;
  vertical-align: top;
  padding: 5px 0 0 5px;
}
.select-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.select-mask .select-mask-blank {
  width: 100%;
  height: 100%;
}
.select-mask .select-mask-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  font-size: 15px;
  height: 300px;
  overflow-y: auto;
}
.select-mask .select-mask-inner .select-mask-content {
  padding: 0 15px;
}
.select-mask .select-mask-inner .head-mask {
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f6f6f6;
  position: relative;
}
.select-mask .select-mask-inner .head-mask .close-mask {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 10px;
}
.select-mask .select-mask-inner .select-mask-content .level {
  border-bottom: 1px solid #f6f6f6;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  position: relative;
}
.select-mask .select-mask-inner .select-mask-content label {
  display: block;
  border-bottom: 1px solid #f6f6f6;
  padding: 5px 15px;
}
>>>
.mint-switch-core {
  width: 42px;
  height: 22px;
}
>>>
.mint-switch-core::before {
  width: 40px;
  height: 20px;
}
>>>
.mint-switch-core::after {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/Stocktaking/StocktakingDetail.vue